module.exports = __webpack_public_path__ + "img/cogPZSOT.bed14627.svg";